/**
 * The colours a class can be given.
 *
 * Deliberately a fixed, muted set rather than a free colour picker: a dozen
 * choices are enough to tell even a packed week's classes apart, they are all
 * legible against both the light and dark surfaces, and a fixed list keeps the
 * schedule looking composed rather than assembled at random.
 */
export const CLASS_COLORS = [
  '#6b4f8a', // plum
  '#2f7d6a', // pine
  '#b4632b', // amber
  '#37618f', // slate blue
  '#8a3c5c', // wine
  '#5c6b2f', // olive
  '#2f6b7d', // teal
  '#4f5c9e', // indigo
  '#9e3a33', // brick
  '#8a7250', // taupe
  '#a05c86', // rose
  '#5f6570', // graphite
] as const;

export const DEFAULT_CLASS_COLOR = CLASS_COLORS[0];

/** Cycles the palette so consecutively added classes look different. */
export function nextClassColor(existingCount: number): string {
  return CLASS_COLORS[existingCount % CLASS_COLORS.length] as string;
}

/** Names for the swatch labels, so the picker is usable without sight of it. */
export const CLASS_COLOR_NAMES: Record<string, string> = {
  '#6b4f8a': 'plum',
  '#2f7d6a': 'pine',
  '#b4632b': 'amber',
  '#37618f': 'blue',
  '#8a3c5c': 'wine',
  '#5c6b2f': 'olive',
  '#2f6b7d': 'teal',
  '#4f5c9e': 'indigo',
  '#9e3a33': 'brick',
  '#8a7250': 'taupe',
  '#a05c86': 'rose',
  '#5f6570': 'graphite',
};

export function colorName(hex: string): string {
  return CLASS_COLOR_NAMES[hex.toLowerCase()] ?? hex;
}
